<template lang="html">
  <div>
    <div class="d-flex align-center justify-left">
      <div class="pl-0">
        1 WISE =
      </div>
      <div class="text-right ml-3 mr-1" >
        <div class="justify-end font-weight-bold"  >
          {{ currentPriceUSD | toCurrency(3, "USD") }}
        </div>
        <div class="justify-end font-weight-bold" >
          {{currentPriceETH | toInt(6, "ETH")}}
        </div>
      </div>
      <div class="text-caption ml-0" >
        <div class="text-right">
          <span :class="currentPriceChange24hUSDClass">{{ currentPriceChange24hUSD | toInt(2, "")}}%</span>
        </div>
        <div class="text-right">
          <span :class="currentPriceChange24hETHClass">{{ currentPriceChange24hETH | toInt(2, "")}}%</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {
    mapState
  } from 'vuex';

  export default {
    data() {
      return {
        currentPriceETH: 0,
        currentPriceUSD: 0,
        currentPriceChange24hETH: 0,
        currentPriceChange24hUSD: 0,
        currentPriceChange24hETHClass: "changeUp",
        currentPriceChange24hUSDClass: "changeUp",
        initialPriceETH: 55900.80344143941383017 / 260760440.016238701274314313,
        initialPriceUSD: 55900.80344143941383017 / 260760440.016238701274314313 * 747.35,
        // roiFactorUSD: 1.666,
        // roiFactorETH: 1.777,
      }
    },
    computed: {
      ...mapState({
        currentUniswapStats: state => state.currentUniswapStats,
        currentETHPrice: state => state.currentETHPrice,
        coingeckoStats: state => state.coingeckoStats
      }),
    },
    mounted() {
      this.updatePriceData();
    },
    watch: {
      currentUniswapStats() {
        this.updatePriceData();
      },
      currentETHPrice() {
        this.updatePriceData();
      },
      coingeckoStats() {
        this.updatePriceData();
      }
    },
    methods: {
      receivedAllNeededData() {
        return (
          this.$store.state.currentUniswapStats.priceETH >= 0 &&
          this.$store.state.currentETHPrice >= 0 &&
          this.$store.state.coingeckoStats.change_24h_usd !== 0 &&
          this.$store.state.coingeckoStats.change_24h_eth !== 0
        );
      },
      updatePriceData() {
        if (!this.receivedAllNeededData()) {
          return;
        }
        this.currentPriceETH = this.$store.state.currentUniswapStats.priceETH;
        this.currentPriceUSD = this.$store.state.currentETHPrice * this.$store.state.currentUniswapStats.priceETH;
        this.currentPriceChange24hUSD = this.$store.state.coingeckoStats.change_24h_usd;
        this.currentPriceChange24hUSDClass = this.currentPriceChange24hUSD >= 0 ? "changeUp" : "changeDown";
        this.currentPriceChange24hETH = this.$store.state.coingeckoStats.change_24h_eth;
        this.currentPriceChange24hETHClass = this.currentPriceChange24hETH >= 0 ? "changeUp" : "changeDown";
        // this.roiFactorUSD = this.currentPriceUSD / this.initialPriceUSD;
        // this.roiFactorETH = this.currentPriceETH / this.initialPriceETH;
      },
    }

  }
</script>

<style lang="css" scoped>
.changeDown {
  font-size: 0.8em;
  color: red;
}
.changeUp {
  font-size: 0.8em;
  color: green;
}
</style>
